import { gql, useQuery } from "@apollo/client";
import { ethers } from "ethers";
import { useAccount } from "wagmi";
import { ceil, orderBy } from "lodash";
import moment from "moment";
import { icons } from "utils/constants";
import FlowRate from "./FlowRate";
import "./Stream.scss";
import { useSelector } from "react-redux";

const GET_LOCATIONS = gql`
  query ($id: ID = "") {
    account(id: $id) {
      createdAtTimestamp
      createdAtBlockNumber
      isSuperApp
      updatedAtBlockNumber
      updatedAtTimestamp
      outflows {
        id
        currentFlowRate
        createdAtTimestamp
        updatedAtTimestamp
        streamedUntilUpdatedAt
        sender {
          id
        }
        receiver {
          id
        }
      }
    }
  }
`;

const Stream = ({ tokenBalance, globalChainID }) => {
  const accountData = useAccount();
  const { address } = accountData;
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const { data = {} } = useQuery(GET_LOCATIONS, {
    variables: {
      id: address.toLowerCase(),
    },
  });

  const { account } = data;
  const { outflows = [] } = account || {};
  const displayData = orderBy(outflows, "createdAtTimestamp", "desc");
  let totalOutFlow = 0;
  displayData.forEach((e) => {
    if (e?.currentFlowRate !== "0") {
      let monthlyRate = +e.currentFlowRate * 2.592e6;
      let outFlowRate = ceil(ethers.utils.formatUnits(`${monthlyRate}`, 18));
      totalOutFlow = totalOutFlow + outFlowRate;
    }
  });

  return (
    <>
      <div id="stream-container">
        <div
          className={`shadow cmt-26 pt-2 br-20 ${
            isDarkMode ? "b-1129" : "b-e3e3"
          }  anim ${isDarkMode ? "bg-4d6c" : ""}`}
        >
          <div
            className={`d-flex ${
              isDarkMode ? "bb-1129" : "bb-e3e3"
            }  cps-24 cpe-24 cpb-10`}
          >
            <div
              className={`pw-30 text-14-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              }`}
            >
              Asset
            </div>
            <div
              className={`pw-20 text-14-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              }`}
            >
              Balance
            </div>
            <div
              className={`pw-25 text-14-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              }`}
            >
              Net Flow
            </div>
            <div
              className={`pw-25 text-14-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              }`}
            >
              Outflow
            </div>
            {/* <div className="pw-10" /> */}
          </div>
          <div
            className={`fa-center cps-24 cpe-24 cpt-10 cpb-15 ${
              isDarkMode ? "bb-1129" : "bb-e3e3"
            }`}
          >
            <div className="pw-30">
              <span className="fa-center gap-2">
                <span className="h-26">
                  <img
                    src={icons.unodeChain}
                    alt="unodeChain"
                    className="fit-image"
                  />
                </span>
                <span
                  className={`text-18-500 ${isDarkMode ? "color-ffff" : ""}`}
                >
                  {globalChainID === 1
                    ? "FUNDx"
                    : globalChainID === 137
                    ? "fxFUNDx"
                    : "FUND"}
                </span>
              </span>
            </div>
            <div
              className={`pw-20 text-15-500 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              {tokenBalance}{" "}
              {globalChainID === 1
                ? "FUNDx"
                : globalChainID === 137
                ? "fxFUNDx"
                : "FUND"}
            </div>
            <div
              className={`pw-25 text-15-500 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              -{totalOutFlow}/mo
            </div>
            <div
              className={`pw-25 text-15-500 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              <div className="color-dc35">-{totalOutFlow}/mo</div>
            </div>
            {/* <div className="pw-10">
              <span
                className="d-flex h-20 pointer"
                onClick={() => {
                  setExpand(!expand);
                }}
              >
                <img
                  src={expand ? icons.arrowCircleUp : icons.arrowCircleDown}
                  alt="arrowCircleDown"
                  className="fit-image"
                />
              </span>
            </div> */}
          </div>

          <div>
            <div
              className={`${
                isDarkMode ? "bb-1129" : "bb-e3e3"
              } fb-center gap-3 cps-24 cpe-24 cpt-15 cpb-15`}
            >
              <div
                className={`text-15-500 ${
                  isDarkMode ? "color-ffff" : "color-2749"
                }`}
              >
                Outgoing ({displayData.length})
              </div>
              {/* <div className="text-15-500 color-2749">{tokenBalance} FUND</div> */}
            </div>

            <div
              className={`fa-center ${
                isDarkMode ? "bb-1129" : "bb-e3e3"
              } cps-24 cpe-24 cpt-10 cpb-10`}
            >
              <div className="pw-5" />
              <div
                className={`pw-20 text-14-400 ${
                  isDarkMode ? "color-c9c9" : "color-7e91"
                }`}
              >
                To / From
              </div>
              <div
                className={`pw-20 text-14-400 ${
                  isDarkMode ? "color-c9c9" : "color-7e91"
                }`}
              >
                All Time Flow
              </div>
              <div
                className={`pw-20 text-14-400 ${
                  isDarkMode ? "color-c9c9" : "color-7e91"
                }`}
              >
                Flow rate
              </div>
              <div className="pw-5" />
              <div
                className={`pw-20 text-14-400 ${
                  isDarkMode ? "color-c9c9" : "color-7e91"
                }`}
              >
                Start / End Date
              </div>
              <div className="pw-10" />
            </div>
            <div
              className={`outflow-list ${
                isDarkMode ? "custom-scroll-dark" : "custom-scroll"
              }`}
            >
              {displayData.map((elm, index) => {
                const {
                  currentFlowRate,
                  createdAtTimestamp,
                  updatedAtTimestamp,
                  receiver = {},
                  streamedUntilUpdatedAt,
                } = elm;
                const recieverID = `${receiver?.id.substring(
                  0,
                  6
                )}...${receiver?.id.substring(
                  receiver?.id.length - 4,
                  receiver?.id.length
                )}`;

                const startDate = moment
                  .unix(createdAtTimestamp)
                  .format("DD MMM. YYYY HH:MM");
                const endDate = moment
                  .unix(updatedAtTimestamp)
                  .format("DD MMM. YYYY HH:MM");
                let nw = +currentFlowRate * 2.592e6;
                let outFlowRate = ceil(ethers.utils.formatUnits(`${nw}`, 18));
                return (
                  <div
                    className={`fa-center cps-24 cpe-24 ${
                      isDarkMode ? "bb-1129" : "bb-e3e3"
                    }  cpt-10 cpb-10`}
                    key={index}
                  >
                    <div className="pw-5">
                      <span className="h-20 d-flex">
                        <img
                          src={
                            isDarkMode
                              ? icons.arrowRightLight
                              : icons.arrowRight
                          }
                          alt="arrowRight"
                          className="fit-image"
                        />
                      </span>
                    </div>
                    <div
                      className={`pw-20 text-15-500 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      }`}
                    >
                      {recieverID}
                    </div>
                    <div
                      className={`pw-20 text-15-500 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      }`}
                    >
                      <FlowRate
                        rate={streamedUntilUpdatedAt}
                        isFlow={currentFlowRate !== "0"}
                        currentFlowRate={currentFlowRate}
                      />
                    </div>
                    <div
                      className={`pw-20 text-15-500 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      }`}
                    >{`${
                      currentFlowRate === "0" ? "-" : `-${outFlowRate}/mo`
                    }`}</div>
                    <div className="pw-5">
                      {currentFlowRate !== "0" && (
                        <span className="h-26 d-flex">
                          <img
                            src={icons.infinity}
                            alt="infinity"
                            className="fit-image"
                          />
                        </span>
                      )}
                    </div>
                    <div
                      className={`pw-20 text-15-500 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      }`}
                    >
                      <div>{startDate}</div>
                      {currentFlowRate === "0" && <div>{endDate}</div>}
                    </div>
                    <div className="pw-10" />
                  </div>
                );
              })}
              {displayData.length === 0 && (
                <div className="f-center h-100">
                  <div>
                    <div style={{ height: "100px" }}>
                      <img
                        src={
                          isDarkMode
                            ? icons.emptyProjectLight
                            : icons.emptyProject
                        }
                        alt="emptyProject"
                        className="fit-image"
                      />
                    </div>
                    <div
                      className={`text-16-600 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      } mt-3`}
                    >
                      You haven’t any outflow
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="fa-center cps-24 cpe-24 cpt-20 cpb-6" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Stream;
